import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { AXIOS_ERROR_MESSAGE } from "../../../../locales/components/namespaces";
import CopyToClipboard from "../../general/copyToClipboard/copyToClipboard.jsx";

const AxiosErrorMessage = ({ customMessage, code, errorCode, errorMessage, responseMessage }) => {
	const [displayMore, setDisplayMore] = useState(false)
	const { t } = useTranslation(AXIOS_ERROR_MESSAGE)
	let moreMessage = ``
	if (code) moreMessage += `${t('Code')}: ${code} `
	if (errorCode) moreMessage += `${t('Status')}: ${errorCode} `
	if (errorMessage) moreMessage += `${t('Message')}: ${errorMessage}`
	if (responseMessage) moreMessage += `${responseMessage}`
	return (
		<Box>
			<Typography
				variant={'body2'}
			>
				{customMessage}
			</Typography>
			{moreMessage && (
				<>
					<Button
						sx={{
							p: 0,
							m: 0
						}}
						size={'small'}
						endIcon={displayMore ? <ExpandLess/> : <ExpandMore/>}
						onClick={() => setDisplayMore(!displayMore)}
					>
						{displayMore ? t('Less') : t('More')}
					</Button>
					{displayMore && (
						<CopyToClipboard
							text={moreMessage}
						/>
					)}
				</>
			)}
		</Box>
	);
};

export default AxiosErrorMessage